import { SearchState } from './Algolia.model'
import { CenterFeedPlacement } from './Center.model'
import { PageType } from './PageType.model'
import { PrimaryFocus } from '@/domain/primaryFocus/constant'
export enum FeedOptions {
  Top = 'topOfFeed',
  Organic = 'organic',
  MidFeed = 'midFeed',
  Local = 'local',
  Explore = 'explore',
  Nearby = 'nearby',
  Carousel = 'carousel',
  FilterWizard = 'filterWizard',
  Element = 'element',
  NearbyHeader = 'nearbyHeader',
  Destinations = 'destinations'
}

export enum CarouselType {
  Insurance = 'insurance',
  TopLocations = 'topLocations',
  NationWide = 'nationWide'
}

export type Header = {
  title: string
  location?: string
  term?: string
}

type RepeatPattern = {
  repeatEvery: number
  itemsToAdd: number
}

export type InFeedProperties = {
  feedSource: FeedOptions
  repeatEvery?: number
  repeatPattern?: RepeatPattern[]
  maxItems?: number
}

export type FeedProperty = {
  feedType: FeedOptions
  positionStart?: number
  itemType?: string
  inFeed?: InFeedProperties
  maxItems?: number
  header?: Header
}

export type Feed = {
  [k in FeedOptions]: keyof typeof FeedOptions
} & {
  [k: string]: keyof typeof FeedOptions
}[]

export enum Kevel_Zone_Ids {
  Destination = 264291,
  MidFeed = 258620,
  Organic = 264289,
  Nearby = 257152,
  Featured = 264290,
  FeedOtherZone = 280648,
  ParentCenterLocations = 281190,
  TaxNearby = 281186,
  Similar = 281077,
  Local = 281220
}

export type ScoringData = {
  searchState: SearchState
  title: string
  locationType: string
  pageType: PageType
  primaryFocus?: PrimaryFocus
}

export enum FeedItemEnum {
  local = 'localItems',
  organic = 'organicItems',
  nearby = 'nearbyItems',
  midFeed = 'midFeedAdsItems'
}

export type FeedItems = {
  [K in FeedItemEnum]: Partial<CenterFeedPlacement>[]
}
